import apiClient from './api'
import { OrderReportDetail, VideoFrame, FluidItem } from '../types'

/**
 * Получить детали отчета по заказу
 * @param orderId - ID заказа
 * @returns Детали отчета
 */
export async function getOrderReportDetail(orderId: string): Promise<OrderReportDetail> {
  try {
    const response = await apiClient.get<OrderReportDetail>('/order/getReportDetail', {
      params: {
        id: orderId,
      },
    })
    return response.data
  } catch (error) {
    throw error
  }
}

// preview=true — отчёт открыт из портала дилера/админки, бэк не засчитывает это как просмотр клиентом
export async function reportViewed(orderId: string, preview = false): Promise<void> {
  try {
    const params = preview ? { orderId, preview: true } : { orderId }
    await apiClient.post('/order/reportViewed', null, { params })
  } catch (err) {
    console.error(`[ERROR] reportViewed failed — orderId: ${orderId}`, err)
  }
}

export async function getOrderFrames(orderId: string): Promise<VideoFrame[]> {
  try {
    const response = await apiClient.get<VideoFrame[]>(`/orders/${orderId}/frames`)
    return response.data.slice().sort((a, b) => a.frameIndex - b.frameIndex)
  } catch (err) {
    console.error(`[ERROR] Failed to load frames — orderId: ${orderId}`, err)
    return []
  }
}

export async function getFluidSpecs(vin: string): Promise<FluidItem[] | null> {
  try {
    const response = await apiClient.get<FluidItem[]>(`/cars/${vin}/fluid-specs`)
    return response.data
  } catch (err: any) {
    if (err?.response?.status !== 404) {
      console.error(`[ERROR] Failed to load fluid specs — vin: ${vin}`, err)
    }
    return null
  }
}
